export const SECURE_EXAM_STYLE_ID = 'virgil-closed-book-print';

export const SECURE_EXAM_PRINT_CSS = `
.secure-exam-content {
  user-select: none;
  -webkit-user-select: none;
}
.secure-exam-input,
.secure-exam-textarea,
.secure-exam-content input,
.secure-exam-content textarea,
.secure-exam-content [contenteditable="true"],
.secure-exam-content [data-allow-copy="true"] {
  user-select: text;
  -webkit-user-select: text;
}
@media print {
  body.secure-exam-print-block * {
    visibility: hidden !important;
  }
  body.secure-exam-print-block::before {
    content: "Printing is disabled during this secure examination.";
    visibility: visible !important;
    display: block;
    padding: 2rem;
    font-size: 1.25rem;
  }
}
`;

export function injectSecureExamStyles() {
  if (typeof document === 'undefined') return () => {};
  if (document.getElementById(SECURE_EXAM_STYLE_ID)) return () => {};
  const el = document.createElement('style');
  el.id = SECURE_EXAM_STYLE_ID;
  el.textContent = SECURE_EXAM_PRINT_CSS;
  document.head.appendChild(el);
  return () => {};
}
